/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchTopicSync} from '../api'

export const useMutationBatchTopicSync = createReactQueryMutationHook('batchTopicSync', batchTopicSync)
